import type { Column } from '@tanstack/react-table';
import { getTableColumnDef } from '../internal/getTableColumnDef';

interface TableHeadFilterProps {
  column: Column<any>;
}

export const TableHeadFilter = ({ column }: TableHeadFilterProps) => {
  const { Filter } = getTableColumnDef(column);

  if (Filter) {
    return <Filter column={column} layout="header" />;
  }

  return null;
};
